import { useTranslation } from 'react-i18next';
import React from 'react';

import { replaceUnderscoreToDash } from 'helpers/utils';

import { Text } from 'components/library';

import * as S from './styled';

import { IUpcomingProductProps } from '../types';

import StatusIcon from './StatusIcon';
import PriceRow from './PriceRow';
import { IncludedInYourPlanRow } from './IncludedInYourPlanRow';

const UpcomingProduct = ({ upcomingProduct, isUpgrade }: IUpcomingProductProps) => {
  const { t } = useTranslation();

  const autoRenewalDate = upcomingProduct.started_from;

  return (
    <S.GeneralInfo $mb={0} $mt={24}>
      <S.Status>
        <StatusIcon isActive={false} />
        <Text type="caption" color="text-secondary">
          {t('subscription.status.upcoming')}
        </Text>
        <Text type="caption" color="text-secondary">
          :
        </Text>
      </S.Status>
      <PriceRow
        price={`${upcomingProduct?.price} ${upcomingProduct.currency}`}
        period={upcomingProduct.subscription_period}
        subscriptionType={t('subscription.type.subscription')}
      />
      {isUpgrade && <IncludedInYourPlanRow />}
      <S.DateInfo data-locator="autoRenewalDate">
        <Text type="caption" color="text-secondary-subdued">
          {t('subscription.text.autoRenewalOn')}
        </Text>
        <Text type="caption" color="text-secondary-subdued">
          {replaceUnderscoreToDash(autoRenewalDate)}
        </Text>
      </S.DateInfo>
    </S.GeneralInfo>
  );
};

export default UpcomingProduct;
